module.exports = __webpack_public_path__ + "static/media/bruce4.e4c0b3b1.mp3";